module.exports = __webpack_public_path__ + "static/article-slide-3-086e9c6efe19ed4654e53388efd7c9fb.jpg";